<app-base-overlay [title]="'Link Company To Tenant'">

  <div body>
    <form
      [formGroup]="linkCompanyToTenantForm"
      class="flex flex-col justify-center items-center gap-4 w-full"
    >

      <app-dropdown
        class="w-full"
        [formControlName]="'companyId'"
        [title]="'Select Company'"
        [display]="'companyName'"
        [value]="'id'"
        [items]="getCompanyListState.response()?.data ?? []"
        [fullWidth]="true">
      </app-dropdown>

    </form>
  </div>

  <div actions>
    <app-button
      class="w-full"
      [iconSrc]="'assets/icons/link.svg'"
      [fullWidth]="true"
      [loading]="linkCompanyToTenantState.loading()"
      (click)="linkCompanyToTenant()">
      Link
    </app-button>
  </div>

</app-base-overlay>
